import { getRequest, postRequest } from '../utils/axios';

export const authService = {
  login: (email, password, onSuccess, onError) =>
    postRequest('/api/token/', { username: email, password }, onSuccess, onError),
  register: (data, onSuccess, onError) =>
    postRequest('/api/in/register/', data, onSuccess, onError),
  fetchUser: (onSuccess, onError) => getRequest('/api/in/user-config/', onSuccess, onError),
  logout: () => {
    localStorage.clear();
  },
};
